module.exports = __webpack_public_path__ + "img/ry_16.57209514.png";